import { configureStore } from '@reduxjs/toolkit'
import globalFiltersReducer from './globalFiltersSlice'

export const store = configureStore({
  reducer: {
    globalFilters: globalFiltersReducer,
  },
})

// Types
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export { useSliceDispatch } from './hooks/useSliceDispatcher'
export { useMultiSelector, useSliceSelector } from './hooks/useSliceSelector'
